/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsBookOpen: {
  name: 'book-open';
  data: string;
} = {
  name: 'book-open',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.137.52A.5.5 0 0 0 .5 1v12a.5.5 0 0 0 .363.48l6.989 1.998a.5.5 0 0 0 .142.022h.012a.5.5 0 0 0 .142-.022l6.99-1.997A.5.5 0 0 0 15.5 13V1a.5.5 0 0 0-.637-.48L8 2.48 1.137.52ZM8.5 14.336l6-1.714V1.663l-6 1.714v10.96Zm-1-10.96-6-1.714v10.96l6 1.714V3.377Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
